










































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { classPrintWorld } from '@/common/js/PrintWorld';
import appconst from '@/lib/appconst';

@Component({ name: 'PrintWaybillForm' }) // 无局部注册，依赖项目全局注册iView
export default class PrintWaybillForm extends Vue {
    // 1. 接收父组件传递的v-model值和行数据
    @Prop({ default: false }) value!: boolean;
    @Prop({ required: true }) rowData!: any;

    // 2. 响应式数据
    boxNumber: string = ''; // 箱号（直接绑定输入框）
    selectedPrinter: string = ''; // 选中的打印机
    printerList: any[] = []; // 打印机列表
    private printerCacheKey = 'print_printer_last_selection'; // 打印机缓存key

    // 3. 弹框打开时加载打印机+恢复缓存
    @Watch('value', { immediate: true })
    onModalVisibleChange(val: boolean) {
        if (val) {
            // 打开弹框：重置箱号 + 加载打印机
            this.boxNumber = '';
            this.printerList = [];
            this.$nextTick(() => {
                this.loadPrinters(); // 延迟加载，确保DOM渲染完成
            });
        }
    }

    // 4. 加载打印机列表+恢复上次选择
    loadPrinters() {
        try {
            const result = new classPrintWorld().Direct({
                action: "printers",
                refresh: true,
                defaultprn: true,
                error: "",
                val: {}
            });

            // 传统判断，无可选链
            if (!result || (result.error && result.error !== '')) {
                const errorMsg = result && result.error ? result.error : "加载打印机失败";
                this.$Message.error(errorMsg);
                return;
            }

            // 格式化打印机列表
            this.printerList = Object.values(result.val);
            if (this.printerList.length === 0) {
                this.selectedPrinter = '';
                return;
            }

            // 步骤1：先恢复本地缓存的打印机
            const lastPrinter = localStorage.getItem(this.printerCacheKey);
            if (lastPrinter && this.printerList.some(item => item.name === lastPrinter)) {
                this.selectedPrinter = lastPrinter;
            } else {
                // 步骤2：无缓存则默认选中第一台
                this.selectedPrinter = this.printerList[0].name;
                // 同步缓存默认打印机
                this.savePrinterCache(this.selectedPrinter);
            }
        } catch (err) {
            this.$Message.error("加载打印机异常");
            this.selectedPrinter = '';
        }
    }

    // 5. 缓存选择的打印机（本地存储，页面刷新不丢失）
    savePrinterCache(printerName: string) {
        if (printerName) {
            localStorage.setItem(this.printerCacheKey, printerName);
        }
    }

    // 6. 执行打印（核心逻辑：无可选链+打印完成不关闭弹框）
    handlePrint() {
        // 校验
        if (!this.selectedPrinter) {
            this.$Message.warning("请选择打印机");
            return;
        }

        const rowData = this.rowData;
        const packingDetailList = rowData.packingDetailList || [];
        if (packingDetailList.length === 0) {
            this.$Message.warning("暂无装箱数据，无法打印");
            return;
        }

        // 分两种场景处理
        if (this.boxNumber.trim()) {
            // 场景1：输入了箱号，打印指定箱号
            this.printSingleBox(this.boxNumber.trim());
        } else {
            // 场景2：未输入箱号，去重后循环打印所有唯一箱号
            this.printAllUniqueBoxes(packingDetailList);
        }
    }

    // 7. 浏览器预览（核心逻辑：复用数据处理，仅打开新窗口预览PDF）
    handlePreview() {
        const rowData = this.rowData;
        const packingDetailList = rowData.packingDetailList || [];
        if (packingDetailList.length === 0) {
            this.$Message.warning("暂无装箱数据，无法预览");
            return;
        }

        // 分两种场景处理，与打印逻辑一致
        if (this.boxNumber.trim()) {
            // 场景1：输入了箱号，预览指定箱号
            this.previewSingleBox(this.boxNumber.trim());
        } else {
            // 场景2：未输入箱号，去重后循环预览所有唯一箱号
            this.previewAllUniqueBoxes(packingDetailList);
        }
    }

    // 8. 打印单个指定箱号（移除可选链，不关闭弹框）
    printSingleBox(boxNumStr: string) {
        const rowData = this.rowData;
        const targetBox = parseInt(boxNumStr);
        if (isNaN(targetBox)) {
            this.$Message.warning("请输入有效的数字箱号");
            return;
        }

        // 筛选指定箱号的数据
        const filteredList = (rowData.packingDetailList || []).filter((item: any) => item.boxNumber === targetBox);
        if (filteredList.length === 0) {
            this.$Message.warning(`未找到箱号为${targetBox}的装箱数据`);
            return;
        }

        // 生成PDF地址并打印
        this.sendPrintRequest(filteredList, rowData, targetBox);
    }

    // 9. 预览单个指定箱号
    previewSingleBox(boxNumStr: string) {
        const rowData = this.rowData;
        const targetBox = parseInt(boxNumStr);
        if (isNaN(targetBox)) {
            this.$Message.warning("请输入有效的数字箱号");
            return;
        }

        // 筛选指定箱号的数据
        const filteredList = (rowData.packingDetailList || []).filter((item: any) => item.boxNumber === targetBox);
        if (filteredList.length === 0) {
            this.$Message.warning(`未找到箱号为${targetBox}的装箱数据`);
            return;
        }

        // 生成PDF地址并在新窗口预览
        this.openPdfPreview(filteredList, rowData, targetBox);
    }

    // 10. 去重并打印所有唯一箱号（移除可选链，不关闭弹框）
    printAllUniqueBoxes(packingDetailList: any[]) {
        // 提取所有箱号并去重+升序排序
        const boxNumbers = packingDetailList.map((item: any) => item.boxNumber);
        const uniqueBoxNumbers = Array.from(new Set(boxNumbers)).sort((a, b) => a - b);

        if (uniqueBoxNumbers.length === 0) {
            this.$Message.warning("暂无有效箱号数据，无法打印");
            return;
        }

        // 循环打印每个唯一箱号
        let successCount = 0;
        let failCount = 0;
        const failBoxes: number[] = [];

        uniqueBoxNumbers.forEach((boxNum) => {
            const filteredList = packingDetailList.filter((item: any) => item.boxNumber === boxNum);
            try {
                const rowData = this.rowData;
                const packingData = {
                    BoxBatchNumber: rowData.boxBatchNumber || '',
                    ShippingMark: rowData.shippingMark || '',
                    PackingDetailList: filteredList,
                    MaxBox: rowData.maxBox || 0
                };

                const pdfUrl = `${appconst.remoteServiceBaseUrl}api/File/GetPackPdf?infos=${encodeURIComponent(JSON.stringify(packingData))}`;
                const result = new classPrintWorld().Direct({
                    action: "printfile",
                    format: "pdf_url",
                    content: pdfUrl,
                    cert: "https://tkyc.ddtmx.com/cer/fileprintauth.ctf",
                    printer: this.selectedPrinter,
                    paperlength: 100,
                    paperwidth: 100
                });

                if (result && result.error && result.error !== '') {
                    failCount++;
                    failBoxes.push(boxNum);
                } else {
                    successCount++;
                }
            } catch (err) {
                failCount++;
                failBoxes.push(boxNum);
            }
        });

        // 打印完成汇总提示
        let tipMsg = `打印完成：成功${successCount}个箱号，失败${failCount}个箱号`;
        if (failBoxes.length > 0) {
            tipMsg += `，失败箱号：${failBoxes.join(',')}`;
        }
        this.$Message.success(tipMsg);
    }

    // 11. 去重并预览所有唯一箱号
    previewAllUniqueBoxes(packingDetailList: any[]) {
        // 提取所有箱号并去重+升序排序
        const boxNumbers = packingDetailList.map((item: any) => item.boxNumber);
        const uniqueBoxNumbers = Array.from(new Set(boxNumbers)).sort((a, b) => a - b);

        if (uniqueBoxNumbers.length === 0) {
            this.$Message.warning("暂无有效箱号数据，无法预览");
            return;
        }

        // 循环预览每个唯一箱号
        let previewCount = 0;
        uniqueBoxNumbers.forEach((boxNum) => {
            const filteredList = packingDetailList.filter((item: any) => item.boxNumber === boxNum);
            try {
                const rowData = this.rowData;
                this.openPdfPreview(filteredList, rowData, boxNum);
                previewCount++;
            } catch (err) {
                this.$Message.error(`箱号${boxNum}预览异常：${(err as Error).message}`);
            }
        });

        // 预览提示
        this.$Message.success(`已为你打开${previewCount}个箱号的PDF预览窗口`);
    }

    // 12. 发送单个打印请求（复用逻辑，不关闭弹框）
    sendPrintRequest(filteredList: any[], rowData: any, boxNum: number) {
        try {
            const packingData = {
                BoxBatchNumber: rowData.boxBatchNumber || '',
                ShippingMark: rowData.shippingMark || '',
                PackingDetailList: filteredList,
                MaxBox: rowData.maxBox || 0
            };

            const pdfUrl = `${appconst.remoteServiceBaseUrl}api/File/GetPackPdf?infos=${encodeURIComponent(JSON.stringify(packingData))}`;
            const result = new classPrintWorld().Direct({
                action: "printfile",
                format: "pdf_url",
                content: pdfUrl,
                cert: "https://tkyc.ddtmx.com/cer/fileprintauth.ctf",
                printer: this.selectedPrinter,
                paperlength: 100,
                paperwidth: 100
            });

            if (result && result.error && result.error !== '') {
                this.$Message.error(`箱号${boxNum}打印失败：${result.error}`);
            } else {
                this.$Message.success(`箱号${boxNum}打印指令已发送`);
            }
        } catch (err) {
            this.$Message.error(`箱号${boxNum}打印异常：${(err as Error).message}`);
        }
    }

    // 13. 打开PDF预览窗口（核心：新窗口打开文件链接）
    openPdfPreview(filteredList: any[], rowData: any, boxNum: number) {
        try {
            const packingData = {
                BoxBatchNumber: rowData.boxBatchNumber || '',
                ShippingMark: rowData.shippingMark || '',
                PackingDetailList: filteredList,
                MaxBox: rowData.maxBox || 0
            };

            // 生成与打印相同的PDF链接
            const pdfUrl = `${appconst.remoteServiceBaseUrl}api/File/GetPackPdf?infos=${encodeURIComponent(JSON.stringify(packingData))}`;

            // 新窗口打开PDF链接，实现浏览器预览
            window.open(pdfUrl, '_blank');

            this.$Message.success(`箱号${boxNum}预览窗口已打开`);
        } catch (err) {
            this.$Message.error(`箱号${boxNum}预览失败：${(err as Error).message}`);
        }
    }
}
